import React from 'react';
import Avatar from '../common/Avatar';

interface StackedAvatarsProps {
  avatars: (string | undefined)[];
  names: string[];
  size?: 'xs' | 'sm' | 'md' | 'lg';
  max?: number;
}

const StackedAvatars: React.FC<StackedAvatarsProps> = ({ 
  avatars, 
  names, 
  size = 'md', 
  max = 2 
}) => {
  const displayAvatars = avatars.slice(0, max);
  const remainingCount = avatars.length - max;

  const sizeClasses = {
    xs: 'h-6 w-6 -ml-2',
    sm: 'h-8 w-8 -ml-3',
    md: 'h-10 w-10 -ml-4',
    lg: 'h-12 w-12 -ml-5'
  };

  return (
    <div className="flex items-center">
      <div className="flex items-center ml-4">
        {displayAvatars.map((src, index) => (
          <div
            key={index}
            className={`${sizeClasses[size]} first:ml-0 transition-transform hover:-translate-y-1`}
            style={{ zIndex: 10 - index }}
            title={names[index]}
          >
            <Avatar
              src={src}
              alt={names[index] || 'User'}
              size={size}
              className="ring-2 ring-white dark:ring-gray-900 shadow-sm"
            />
          </div>
        ))}
        {remainingCount > 0 && (
          <div
            className={`${sizeClasses[size]} flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 border-2 border-white dark:border-gray-900 text-[10px] font-bold text-gray-600 dark:text-gray-400`}
            style={{ zIndex: 0 }}
          >
            +{remainingCount}
          </div>
        )}
      </div>
    </div>
  );
};

export default StackedAvatars;
